import { ProductMappings } from '../types';

export const BASE_URL: string = process.env.REACT_APP_BASE_URL || '';
export const BACKEND_URL: string = process.env.REACT_APP_BACKEND_URL || '';
export const LEGACY_BACKEND_URL: string =
  process.env.REACT_APP_LEGACY_BACKEND_URL || '';
export const ROOTINE_WEB_URL: string =
  process.env.REACT_APP_ROOTINE_WEB_URL || 'https://rootine.co';
export const ROOTINE_APP_URL: string = 'https://app.rhodiumsoftware.com/';
export const ROOTINE_WEB_SCIENCE_URL: string = 'https://rootine.co/pages/science';
export const SHOPIFY_WEB_URL = 'https://rootine.co';

export const PRODUCT_CODE_MAPPING = {
  bloodvitamin: 'bv-test',
  bloodvitamin_subscription: 'bv-test-sus',
  bloodmineral: 'bm-test',
  bloodmineral_subscription: 'bm-test-sus',
  dna: 'd-test',
  vitamins: 'vit-sus',
  dna_blood_bundle: 'bnd-bvd-test',
  blood_bundle: 'bnd-bmbv-test',
  three_test_bundle: 'bnd-bmbvd-test',
  blood_bundle_subscription: 'bnd-bmbv-test-sus',
  cortisol_subscription: 'cor-test-sus',
  cortisol: 'cor-test',
  stress_support: 'vit-str-30',
  stress_unwind: 'vit-unw-30',
  stress_focus: 'vit-foc-30',
  consult_15: 'con-15',
  stress_support_24_pk: 'pdr-str-24',
  sleep_support_24_pk: 'pdr-slp-24',
  focus_support_24_pk: 'pdr-foc-24',
};

// Product variant mappings for Shopify plans
export const SHOPIFY_VARIANT_MAPPINGS: ProductMappings = {
  'vit-sus': {
    id: '40542598201457',
    selling_plan: '1630994545',
  },
  'bm-test-sus': {
    // 6 mo
    id: '40239542763633',
    selling_plan: '1631223921',
  },
  'bm-test': {
    // 12 mo
    id: '40239542763633',
    selling_plan: '1631256689',
  },
  'bv-test-sus': {
    // 6 mo
    id: '39253305458801',
    selling_plan: '1631223921',
  },
  'bv-test': {
    // 12 mo
    id: '39253305458801',
    selling_plan: '1631256689',
  },
  'cor-test': {
    id: '40509611442289',
    selling_plan: '',
  },
  'cor-test-sus': {
    id: '40509611442289',
    selling_plan: '1631223921',
  },
  'd-test': {
    id: '39253311094897',
    selling_plan: '',
  },
  'bnd-bmbvd-test': {
    id: '40531680231537',
    selling_plan: '',
  },
  'pdr-foc-24': {
    id: '40495753265265',
    selling_plan: '',
  },
  'pdr-str-24': {
    id: '40495759261809',
    selling_plan: '',
  },
  'pdr-slp-24': {
    id: '40495455305841',
    selling_plan: '',
  },
};

export const PRODUCT_SLUG_MAPPING = {
  shop_all: 'shop-all',
  at_home_test_collection: 'at-home-lab-tests',
  vitamins: 'smart-multivitamin',
  vitamin_test: 'vitamin-test',
  mineral_test: 'mineral-test',
  dna_test: 'dna-test',
  cortisol_test: 'cortisol-test',
};
export const CHECKOUT_URLS = {
  vitamins: {
    text: 'Order your Precision Micronutrients',
    link: `${ROOTINE_WEB_URL}/a/account/groups/join?magic=eyJwcm9kdWN0cyI6W3sic2VsbGluZ1BsYW5QbGF0Zm9ybUlkIjoiMTYzMDk5NDU0NSIsInByb2R1Y3RWYXJpYW50UGxhdGZvcm1JZCI6IjQwNTQyNTk4MjAxNDU3In1dfQ==`,
  },
  blood_test: {
    text: 'Order Blood Vitamin Test',
    link: `${ROOTINE_WEB_URL}/a/account/groups/join?magic=eyJwcm9kdWN0cyI6W3sic2VsbGluZ1BsYW5QbGF0Zm9ybUlkIjoiMTYzMTI1NjY4OSIsInByb2R1Y3RWYXJpYW50UGxhdGZvcm1JZCI6IjM5MjUzMzA1NDU4ODAxIn1dfQ==`,
  },
  blood_vitamin_subscription: {
    text: 'Order Blood Vitamin Test',
    link: `${ROOTINE_WEB_URL}/a/account/groups/join?magic=eyJwcm9kdWN0cyI6W3sic2VsbGluZ1BsYW5QbGF0Zm9ybUlkIjoiMTYzMTIyMzkyMSIsInByb2R1Y3RWYXJpYW50UGxhdGZvcm1JZCI6IjM5MjUzMzA1NDU4ODAxIn1dfQ==`,
  },
  blood_mineral_test: {
    text: 'Order Blood Mineral Test',
    link: `${ROOTINE_WEB_URL}/a/account/groups/join?magic=eyJwcm9kdWN0cyI6W3sic2VsbGluZ1BsYW5QbGF0Zm9ybUlkIjoiMTYzMTI1NjY4OSIsInByb2R1Y3RWYXJpYW50UGxhdGZvcm1JZCI6IjQwMjM5NTQyNzYzNjMzIn1dfQ==`,
  },
  blood_mineral_subscription: {
    text: 'Order Blood Mineral Test',
    link: `${ROOTINE_WEB_URL}/a/account/groups/join?magic=eyJwcm9kdWN0cyI6W3sic2VsbGluZ1BsYW5QbGF0Zm9ybUlkIjoiMTYzMTIyMzkyMSIsInByb2R1Y3RWYXJpYW50UGxhdGZvcm1JZCI6IjQwMjM5NTQyNzYzNjMzIn1dfQ==`,
  },
  // TODO: Update when shopify has checkout link
  blood_bundle: {
    text: 'Order Blood Test Bundle',
    link: `${ROOTINE_WEB_URL}/collections/${PRODUCT_SLUG_MAPPING.at_home_test_collection}`,
  },
  // Deprecated - no longer offering
  blood_bundle_subscription: {
    text: 'Order Blood Test Bundle',
    link: `${ROOTINE_WEB_URL}/pages/order-now?id=${PRODUCT_CODE_MAPPING.blood_bundle_subscription}`,
  },
  dna_test: {
    text: 'Order DNA Test',
    link: `${ROOTINE_WEB_URL}/cart/39253311094897:1`,
  },
  cortisol_test: {
    text: 'Order Cortisol Test',
    link: `${ROOTINE_WEB_URL}/a/account/groups/join?magic=eyJwcm9kdWN0cyI6W3sic2VsbGluZ1BsYW5QbGF0Zm9ybUlkIjoiMTYzMTI1NjY4OSIsInByb2R1Y3RWYXJpYW50UGxhdGZvcm1JZCI6IjQwNTA5NjExNDQyMjg5In1dfQ==`,
  },
  cortisol_subscription: {
    text: 'Order Cortisol Subscription',
    link: `${ROOTINE_WEB_URL}/a/account/groups/join?magic=eyJwcm9kdWN0cyI6W3sic2VsbGluZ1BsYW5QbGF0Zm9ybUlkIjoiMTYzMTIyMzkyMSIsInByb2R1Y3RWYXJpYW50UGxhdGZvcm1JZCI6IjQwNTA5NjExNDQyMjg5In1dfQ==`,
  },
  // TODO: Update when shopify has subscription product
  coaching: {
    text: '1 on 1 coaching',
    link: `${ROOTINE_WEB_URL}/pages/order-now?id=${PRODUCT_CODE_MAPPING.consult_15}`,
  },
};

export const ANALYTICS_EVENTS = {
  login: 'Dashboard Login',
  product_modal_open: 'Product Recommendation Opened',
  product_modal_close: 'Product Recommendation Closed',
  benefits_quiz_started: 'Benefits Quiz Started',
  benefits_quiz_completed: 'Benefits Quiz Completed',
  newsletter_signup: 'Newsletter Signup',
};

export enum CORTISOL_REPORT_TABS {
  results = 'Results',
  symptoms = 'Symptoms',
  actionPlan = 'Action Plan',
  trackProgram = 'Track Program',
}

export const ACTION_PLAN_CONFIGS = [
  { key: 'diet', label: 'DIET' },
  { key: 'lifestyle', label: 'LIFESTYLE' },
  { key: 'movement', label: 'MOVEMENT' },
  { key: 'sleep', label: 'SLEEP' },
];

// Feature Flags
export enum FeatureFlags {
  JOIN_WAITLIST = 'join_waitlist',
  Q2024_NEW_STRESS_PRODUCTS = 'q2024_new_stress_products',
}
